import { Pipe, PipeTransform } from '@angular/core';
import { RevisionStatus } from 'src/app/shared/models/autogenerated-coating';

@Pipe({
    name: 'revisionStatus',
    standalone: false
})
export class RevisionStatusPipe implements PipeTransform {
  transform(value: RevisionStatus): string {
    switch (value) {
      case RevisionStatus.DRAFT: {
        return 'Draft';
      }
      case RevisionStatus.REVIEW: {
        return 'In Review';
      }
      case RevisionStatus.APPROVAL: {
        return 'Waiting for Approval';
      }
      case RevisionStatus.PUBLISHED: {
        return 'Published';
      }
      default: {
        return '';
      }
    }
  }
}
